import { StorageBucketApi, StorageFileApi } from './lib'
import { Fetch } from './lib/fetch'

export class SupabaseStorageClient extends StorageBucketApi {
  constructor(url: string, headers: { [key: string]: string } = {}, fetch?: Fetch) {
    super(url, headers, fetch)
  }

  /**
   * Perform file operation in a bucket.
   *
   * @param id The bucket id to operate on.
   */
  from(id: string): StorageFileApi {
    return new StorageFileApi(this.url, this.headers, id, this.fetch)
  }
}
